import React, {useEffect, useState} from 'react';
import NavBar from "../../common/NavBar";
import SideBar from "../../common/SideBar";
import Spinner from 'reactjs-simple-spinner';
import DashboardServices from "../../services/DashboardServices";
import {toast, ToastContainer} from "react-toastify";
import {Chart} from "primereact/chart";

const Home = () => {

    const [loading, setLoading] = useState(false);
    const [agents, setAgents] = useState(0)
    const [leads, setLeads] = useState(0)
    const [leadsPercentage, setLeadsPercentage] = useState(0)
    const [paidClaims, setPaidClaims] = useState(0)
    const [savingsDueToMature, setSavingDueToMature] = useState(0)
    const [color, setColor] = useState('text-white')

    const [stackedData, setStackedData] = useState({
        labels: ['January', 'February', 'March', 'April', 'May',
            'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [{
            type: 'bar',
            label: 'Accident Death',
            backgroundColor: '#2c6aec',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }, {
            type: 'bar',
            label: 'Funeral',
            backgroundColor: 'rgb(255,104,36)',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }, {
            type: 'bar',
            label: 'Comprehensive',
            backgroundColor: 'rgb(115,213,187)',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }, {
            type: 'bar',
            label: 'Savings Death',
            backgroundColor: '#979d9c',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }]
    });

    const [refundsStackedData, setRefundsStackedData] = useState({
        labels: ['January', 'February', 'March', 'April', 'May',
            'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [{
            type: 'bar',
            label: 'Deduction of Misrepresentation',
            backgroundColor: '#2c6aec',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }, {
            type: 'bar',
            label: 'Deductions Of Cancellation',
            backgroundColor: 'rgb(255,104,36)',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }, {
            type: 'bar',
            label: 'Deductions After Surrender',
            backgroundColor: 'rgb(115,213,187)',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }, {
            type: 'bar',
            label: 'Over Deductions',
            backgroundColor: '#979d9c',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }, {
            type: 'bar',
            label: 'Other Deductions',
            backgroundColor: 'rgb(210,6,6)',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }]
    });

    const [deathClaimsStackedData, setDeathClaimsStackedData] = useState({
        labels: ['January', 'February', 'March', 'April', 'May',
            'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [{
            type: 'bar',
            label: 'Death Claims',
            backgroundColor: '#2c6aec',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }]
    });

    const [investmentClaimsStackedData, setInvestmentClaimsStackedData] = useState({
        labels: ['January', 'February', 'March', 'April', 'May',
            'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [{
            type: 'bar',
            label: 'Investment Claims',
            backgroundColor: '#73d5bb',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }]
    });

    const [paidClaimsStackedData, setPaidClaimsStackedData] = useState({
        labels: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        datasets: [{
            type: 'bar',
            label: 'Weekly Paid Claims',
            backgroundColor: 'rgba(0,114,86,0.78)',
            data: [0, 0, 0, 0, 0, 0, 0]
        }]
    });

    const getLightTheme = () => {

        let stackedOptions = {
            maintainAspectRatio: false,
            aspectRatio: .8,
            plugins: {
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                legend: {
                    labels: {
                        color: '#495057'
                    }
                }
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                },
                y: {
                    stacked: true,
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                }
            }
        };

        return {
            stackedOptions
        }
    }

    const {stackedOptions} = getLightTheme();

    const months = ['January', 'February', 'March', 'April', 'May',
        'June', 'July', 'August', 'September', 'October', 'November', 'December'];


    let roles = []

    useEffect(() => {
        setLoading(true);
        let token = JSON.parse(localStorage.getItem('token'));
        roles = JSON.parse(localStorage.getItem('roles'));

        console.log("token", token)
        console.log("roles: ", roles)
        DashboardServices.dashboardData()
            .then(res => {
                console.log("dashboard data: ", res.data)
                setAgents(res.data.agents_count);
                setLeads(res.data.leads_count);
                setLeadsPercentage(res.data.leads_count_percent);
                if (res.data.leads_count_percent.includes('-')) {
                    setColor('text-danger');
                } else {
                    setColor('text-success');
                }
                setPaidClaims(res.data.claims_paid_weekly_count);
                setSavingDueToMature(res.data.due_to_mature_count);

                // loop through months
                months.map((date, t) => {
                    console.log("started - and updated ", t);
                    //for each date, browse the stacks and update data accordingly

                    //loop through new data and update data[0] on the datasets object
                    // add data for death claims per product
                    if (res.data.death_claims_by_product.length > 0) {
                        res.data.death_claims_by_product.map((stack, i) => {
                            console.log("key: ", t, " stack: ", stack)
                            console.log('date: ', date, " monthname from db: ", stack.monthname, " is it true: ", date.startsWith(stack.monthname))
                            if (date.startsWith(stack.monthname)) {

                                console.log("index: ", i, "count: ", stack.count)
                                if (stack.product === "ACCIDENT_DEATH") {
                                    stackedData.datasets[0].data.splice(t, 1, stack.count)
                                    console.log("stack at position: ", t, " - ", stackedData.datasets[0].data);
                                } else if (stack.product === "FUNERAL") {
                                    stackedData.datasets[1].data.splice(t, 1, stack.count)
                                    console.log("stack at position: ", t, " - ", stackedData.datasets[1].data);
                                } else if (stack.product === "COMPREHENSIVE") {
                                    stackedData.datasets[2].data.splice(t, 1, stack.count)
                                    console.log("stack at position: ", t, " - ", stackedData.datasets[2].data);
                                } else if (stack.product === "SAVINGS_DEATH") {
                                    stackedData.datasets[3].data.splice(t, 1, stack.count)
                                    console.log("stack at position: ", t, " - ", stackedData.datasets[3].data);
                                }

                                stackedData.labels = months;

                            }
                        })
                        setLoading(false);
                    }

                    //     add data for death claims
                    if (res.data.death_claims.length > 0) {
                        res.data.death_claims.map((stack, i) => {
                            console.log("key: ", t, " stack: ", stack)
                            console.log('date: ', date, " monthname from db: ", stack.monthname, " is it true: ", date.startsWith(stack.monthname))
                            if (date.startsWith(stack.monthname)) {
                                console.log("index: ", i, "count: ", stack.count)
                                deathClaimsStackedData.datasets[0].data.splice(t, 1, stack.count)

                            }
                        })
                        setLoading(false);
                    }

                    //     add data for investment claims
                    if (res.data.monthly_investments_claims.length > 0) {
                        res.data.monthly_investments_claims.map((stack, i) => {
                            console.log("key: ", t, " stack: ", stack)
                            console.log('date: ', date, " monthname from db: ", stack.monthname, " is it true: ", date.startsWith(stack.monthname))
                            if (date.startsWith(stack.monthname)) {
                                console.log("index: ", i, "count: ", stack.count)
                                investmentClaimsStackedData.datasets[0].data.splice(t, 1, stack.count)

                            }
                        })
                        setLoading(false);
                    }

                    //     add data for weekly paid claims
                    if (res.data.claims_paid_weekly.length > 0) {
                        res.data.claims_paid_weekly.map((stack, i) => {
                            console.log("key: ", t, " stack: ", stack)
                            console.log('date: ', date, " monthname from db: ", stack.monthname, " is it true: ", date.startsWith(stack.monthname))
                            if (date.startsWith(stack.monthname)) {
                                console.log("index: ", i, "count: ", stack.count)
                                paidClaimsStackedData.datasets[0].data.splice(t, 1, stack.count)

                            }
                        })
                        setLoading(false);
                    }

                    setLoading(false);
                })

            }).catch(err => {
            console.log("error: ", err)
            toast.warning('Loading data failed\n Please Reload, If error persist kindly contact your administrator.')
            setLoading(false);
        })

    }, [])

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{color: "white"}}
            />

            <div>
                <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>

                <div id="main-content" className="main-panel ps-container ps-theme-default">
                    <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                    <div className="content">
                        {loading && (
                            <div id="login-page">
                                <div className="container">
                                    <form className="loader">
                                        <div className="login-wrap mt-5">
                                            <Spinner
                                                size="medium"
                                                message="Opening Dashboard..."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )}
                        {!loading && (
                            <div className="container-fluid">
                                <ul className="breadcrumb">
                                    <a href><i className="fa fa-home"/>&nbsp;Dashboard</a>
                                </ul>
                                <div className="row">
                                    <div className="col-lg-3 col-md-6 col-sm-6">
                                        <div className="card card-stats">
                                            <div className="card-header card-header-info card-header-icon">
                                                <div className="card-icon">
                                                    <i className="material-icons">group</i>
                                                </div>
                                                <p className="card-category pr-2">New Leads</p>
                                                <h3 className="card-title pr-2">{leads}
                                                    <small></small>
                                                </h3>
                                            </div>
                                            <div className="card-footer">
                                                <div className="stats">
                                                    <i className="material-icons">date_range</i> <span
                                                    className={color + " pr-1 font-weight-bold"}>{leadsPercentage}% </span> than
                                                    last
                                                    month
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-6">
                                        <div className="card card-stats">
                                            <div className="card-header card-header-success card-header-icon">
                                                <div className="card-icon">
                                                    <i className="material-icons">payments</i>
                                                </div>
                                                <p className="card-category pr-2">Claims Paid</p>
                                                <h3 className="card-title pr-2">{paidClaims}</h3>
                                            </div>
                                            <div className="card-footer">
                                                <div className="stats">
                                                    <i className="material-icons">date_range</i> This week
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-6">
                                        <div className="card card-stats">
                                            <div className="card-header card-header-danger card-header-icon">
                                                <div className="card-icon">
                                                    <i className="material-icons">info_outline</i>
                                                </div>
                                                <p className="card-category pr-2">Savings Due To Mature</p>
                                                <h3 className="card-title pr-2">{savingsDueToMature}</h3>
                                            </div>
                                            <div className="card-footer">
                                                <div className="stats">
                                                    <i className="material-icons">local_offer</i> Tracked from Savings
                                                    Policies
                                                    <a className="pl-5 text-right"
                                                       href={'/savings-policies-due-to-mature'}>View the policies</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 col-sm-6">
                                        <div className="card card-stats">
                                            <div className="card-header card-header-primary card-header-icon">
                                                <div className="card-icon">
                                                    <i className="fa-solid fa-users-viewfinder"></i>
                                                </div>
                                                <p className="card-category pr-2">Sales Army</p>
                                                <h3 className="card-title pr-2">{agents}</h3>
                                            </div>
                                            <div className="card-footer">
                                                <div className="stats">
                                                    <i className="material-icons">update</i> Just Updated
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt">
                                    <div className="col-md-12">
                                        {/*<h3 className="font-weight-bold">Analysis </h3>*/}
                                    </div>
                                </div>
                                <hr/>
                                <div className="row mt">
                                    <div className="card col-lg-4 col-md-6 col-sm-6 p-4">
                                        <h4 className="card-title text-secondary">Death Claims Per Product <i
                                            className="fa fa-arrow-down"/></h4>
                                        <Chart type="bar" data={stackedData} options={stackedOptions}/>
                                    </div>
                                    <div className="card col-lg-4 col-md-6 col-sm-6 p-4">
                                        <h4 className="card-title text-secondary">Death Claims (Monthly) <i
                                            className="fa fa-arrow-down"/></h4>
                                        <Chart type="bar" data={deathClaimsStackedData} options={stackedOptions}/>
                                    </div>
                                    <div className="card col-lg-4 col-md-6 col-sm-6 p-4">
                                        <h4 className="card-title text-secondary">Monthly Investment Claims <i
                                            className="fa fa-arrow-down"/></h4>
                                        <Chart type="bar" data={investmentClaimsStackedData} options={stackedOptions}/>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="card col-lg-8 col-md-6 col-sm-6 p-4">
                                        <h4 className="card-title text-secondary">Refund Payments <i
                                            className="fa fa-arrow-down"/></h4>
                                        <Chart type="bar" data={refundsStackedData} options={stackedOptions}/>
                                    </div>
                                    <div className="card col-lg-4 col-md-6 col-sm-6 p-4">
                                        <h4 className="card-title text-secondary">Weekly Claims Paid <i
                                            className="fa fa-arrow-down"/></h4>
                                        <Chart type="bar" data={paidClaimsStackedData} options={stackedOptions}/>
                                    </div>
                                </div>

                            </div>
                        )}
                        </div>
                    </div>


                </div>
        </>
    )
}

export default Home;

